import React from 'react'
import { Link } from 'react-router-dom'

const ParentDirectory = props => {

  if (props.data.length === 0 || props.data.key === 'root') {
    return null
  }

  const parentKey = props.data.parent ? props.data.parent : ''

  return (
    <tr key={props.data.key}>
      <td className='directory' colSpan='4'>
        <Link to={`/files?directory=${parentKey}`}><i className="fad fa-folder"></i> ..</Link>
      </td>
    </tr>
  )
}

export default ParentDirectory
